import { formatCents } from "@/lib/utils"
import { AcceptAction } from "./AcceptAction";
import { QuoteActionDescription } from "./QuoteActionDescription";
import { useOfferContext } from "@/lib/hooks/useOfferContext";
import {DynamicHtmlElement} from "@/components/ui/DynamicHtmlElement";
import {ProductDescriptors} from "@/components/ui/ProductDescriptors";
import {DeclineAction} from "@/components/ui/DeclineAction";
import {FormError} from "@/components/ui/FormError";

export const ProductCardCheckboxList = ({
  product
} : {
  product: string;
}) => {
  const offer = useOfferContext();
  const quotes = offer.quotes[product];

  const displayableQuotes = quotes.filter(q => 'quote_id' in q);
  const quoteForDisplay = displayableQuotes.find(q => 'product' in q);
  const productDetails = quoteForDisplay?.product;

  if (productDetails == null) {
    return null;
  }

  return (
    <div className="flex flex-col border p-2 rounded gap-2">
      <DynamicHtmlElement html={productDetails.promotional_header} className="text-md font-semibold" />
      <DynamicHtmlElement html={productDetails.promotional_description} className="text-sm" />
      <div className="flex flex-col md:flex-row gap-2">
        <ProductDescriptors descriptors={productDetails.descriptors ?? []} />
        <div className="space-y-2 md:max-w-md md:min-w-md">
          {displayableQuotes.map((quote, index) => (
            <AcceptAction key={index} type="checkbox" quoteIds={[quote.quote_id]}>
              <div className="flex-1"><QuoteActionDescription product={product} quote={quote} /></div>
              <div className="font-medium">{formatCents(quote.total, quote.currency)}</div>
            </AcceptAction>
          ))}
          <DeclineAction type="radio"/>
          <FormError />
        </div>
      </div>
      <DynamicHtmlElement html={productDetails.legal_disclaimer} className="text-xs mt-2" />
    </div>
  )
}
